// extracted by mini-css-extract-plugin
export default {"appHeader":"AppHeader_appHeader__ZXb0l","mainCol":"AppHeader_mainCol__fVpBD","rightSide":"AppHeader_rightSide__n8n67"};